// extracted by mini-css-extract-plugin
export default {"large":"only screen and (min-width: 992px)","emptyFeed":"_4DfCg","productCard":"nvJpR","relatedProductsArea":"CPeNc nx-n+ ZPTkf ZDvyr kRUke mRs3u"};